import { render, staticRenderFns } from "./TransferFuelView.vue?vue&type=template&id=08db2cb0&"
import script from "./TransferFuelView.vue?vue&type=script&lang=js&"
export * from "./TransferFuelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports